import React from 'react';

import { useSidebar }   from '../../providers/sidebar';
import sidebarConstants from '../../providers/sidebar/sidebar.constants';

import CallMeFormIcon from '../icons/CallMeFormIcon';

const CallMeFormButton = function() {
  const { showSidebar } = useSidebar();

  return (
    <button
      className={'call_me_form_btn'}
      onClick={() => {
        showSidebar(sidebarConstants.CALL_ME_SIDEBAR, 'Контакт-центр завода');
      }}
      title={'Контакт-центр завода'}
    >
      <CallMeFormIcon />
    </button>
  );
};

export default CallMeFormButton;